import { type FC } from "react";

import { Card, CardRowSimple, type GridCard } from "widgets";
import { formatNumberByThousands } from "widgets/utils";

import { type Protein } from "../../../graphql.js";
import { SelMessage } from "../../../messages/SelMessage.js";

export interface IProteinFeatureContentCardProps extends GridCard {
  protein: Protein;
}

const ProteinFeatureContentCard: FC<IProteinFeatureContentCardProps> = (props) => {
  if (!props.protein) {
    return null;
  }

  const elementList: JSX.Element[] = [];
  const placeholder = <SelMessage id={"noContent.proteinFeaturesContent"} />;

  if (props.protein.featureStatsData.length > 0) {
    props.protein.featureStatsData.map((f) => {
      elementList.push(
        <CardRowSimple
          label={`${f.featureTypeName} feature`}
          value={formatNumberByThousands(f.count)}
          key={"card-row-aa-feature-" + f.featureTypeName}
        />,
      );
    });
  }

  return (
    <Card key="genome-aa-content-card" title={"Protein Features"}>
      {elementList.length > 0 ? elementList : placeholder}
    </Card>
  );
};

export { ProteinFeatureContentCard };
